import React from "react";
import { Wrapper, Title } from "./styled";

const Header = ({ title }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
    </Wrapper>
  );
};

export default Header;
